import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PnButton } from '@privanot/shared-ui/primeng-acl/button';
import { PnIcon } from '@privanot/shared-ui/common/icon';
import { PnLogo } from '@privanot/shared-ui/common/logo';
import { BastionEnrollmentState } from '@client/shared/interfaces/bastion-enrollment.interface';

@Component({
    selector: 'app-bastion-key-gate',
    imports: [PnButton, PnIcon, PnLogo, TranslatePipe],
    templateUrl: './bastion-key-gate.html',
    styleUrl: './bastion-key-gate.scss',
})
export class BastionKeyGate {
    public readonly state = input.required<BastionEnrollmentState>();
    public readonly recheckAction = input<(() => Promise<void>) | undefined>(undefined);

    public readonly icon = computed(() => {
        switch (this.state()) {
            case 'pending':
                return 'clock';
            case 'revoked':
                return 'shield-x';
            case 'rejected':
                return 'circle-x';
            case 'conflict':
                return 'triangle-alert';
            default:
                return 'key-round';
        }
    });

    public readonly titleKey = computed(() => `bastion.${this.state()}.title`);
    public readonly messageKey = computed(() => `bastion.${this.state()}.message`);
}
